import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../components/TableContent';
import { getFlex } from '../utils';

import { DividendHistoryItemTypes } from './types';

export const DividendHistoryItemDesktop: React.FC<DividendHistoryItemTypes.Props> = ({ item }) => {
  return (
    <TableContent direction="row" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.dividendType}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.companyName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.isinCode}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.negotiationCode}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{item.assetName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.assetValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{item.approvalDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>{item.startDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>{item.updateDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(9)}>
        <TableContentItemText>{item.dueDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
